import React from 'react'
import SocialLink from './SocialLink'
import { IoLogoWhatsapp, IoMail } from 'react-icons/io5'
import { FaFacebookF } from 'react-icons/fa'

const Share = ({ type }) => {
  // Get the current URL dynamically
  const currentUrl = window.location.href

  const handleShareMailClick = () => {
    const subject = encodeURIComponent('Digicard - כרטיס ביקור דיגיטלי')
    const mailLink = `mailto:?subject=${subject}&body=${encodeURIComponent(currentUrl)}`
    window.open(mailLink, '_blank')
  }

  const handleShareWhatsappClick = () => {
    const message = encodeURIComponent('כרטיס ביקור דיגיטלי')
    const whatsappLink = `https://wa.me/?text=${message}%0A${encodeURIComponent(currentUrl)}`
    window.open(whatsappLink, '_blank')
  }

  const handleShareFacebookClick = () => {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      currentUrl,
    )}&title=${encodeURIComponent('Digicard - כרטיס ביקור דיגיטלי')}&description=${encodeURIComponent(
      'כרטיס ביקור דיגיטלי',
    )}`
    window.open(facebookLink, '_blank')
  }

  const socialLinksData = [
    { text: '', icon: IoMail, action: handleShareMailClick },
    { text: '', icon: IoLogoWhatsapp, action: handleShareWhatsappClick },
    { text: '', icon: FaFacebookF, action: handleShareFacebookClick },
  ]

  const renderSocialLinks = socialLinksData.map((linkData, index) => (
    <SocialLink key={index} text={linkData.text} icon={linkData.icon} onClickAction={linkData.action} type={type} />
  ))

  return (
    <div data-aos="fade-down" data-aos-easing="ease-in-out" className="pb-20">
      <div>
        <h1 className="text-center text-share_headerColor text-lg underline font-bold">שתפו את הדף הדיגיטלי </h1>
        <div className="w-[200px] flex mx-auto justify-around">{renderSocialLinks}</div>
      </div>
    </div>
  )
}

export default Share
